import { render, staticRenderFns } from "./Statistique.vue?vue&type=template&id=ae066f10"
import script from "./Statistique.vue?vue&type=script&lang=js"
export * from "./Statistique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports